export const BO_LABEL = {
	'-1003': 'Customer',
	'-1007': 'Visitor',
};
